import React,{useEffect, useState} from 'react'
import {FaTimes,FaBars} from 'react-icons/fa';
import { BsSun ,BsMoon } from "react-icons/bs";
import {useNavigate} from "react-router-dom"
function Navbar() {
  const navigate = useNavigate();
    const[theme,setTheme] = useState(null);
    useEffect(()=>{
      if(window.matchMedia('(prefers-color-schema:dark)').matches){
        setTheme('dark');
      }
      else
      {
        setTheme('light');
      }
    },[])
  useEffect(()=>
  {
  if(theme==="dark")
  {
    document.documentElement.classList.add("dark");
  }
  else
  {
    document.documentElement.classList.remove("dark");
  }
  },[theme])
  
  const handleThemeSwitch = ()=>
  {
    setTheme(theme==="dark"?"light":"dark");
  };
    const[nav,setnav] = useState(false);
    const handleClick =()=> setnav(!nav);
  return (
    <div className='sticky top-0 w-full p-3  flex justify-between items-center px-4  dark:bg-[#0a192f] text-gray-00 dark:text-gray-400'>
       <div>
        <p>Computer Networks CBP</p>
       </div>
       <div>
        <ul className='hidden md:flex items-center '>
            <li className='px-4 p-2 hover:border-b-2 hover:border-teal-500'  onClick={()=>navigate("/")}>Home</li>
            <li className='px-4 p-2 hover:border-b-2 hover:border-teal-500'  onClick={()=>navigate("/rsa")}>RSA</li>
            <li className='px-4 p-2 hover:border-b-2 hover:border-teal-500'  onClick={()=>navigate("/authors")}>Authors</li>
            <li className='px-4 '><div>
        <button className=' p-4 ' onClick={handleThemeSwitch}>
    {
      theme ==="dark" && <BsSun/>
    }
    {
      theme==="light" && <BsMoon/>
    }
    </button>

        </div> </li>
        </ul>
       </div>
       {/* Hamburger */}
       <div onClick={handleClick} className='md:hidden z-10'>
       {!nav? <FaBars/>:<FaTimes/>} 
       </div>
      
       <ul className={!nav?'hidden': 'md:hidden absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center dark:text-gray-400' }>
       <li className='py-6 text-4xl' onClick={()=>navigate("/")}>Home</li>
            <li className='py-6 text-4xl'  onClick={()=>navigate("/rsa")}>RSA</li>
            <li className='py-6 text-4xl'  onClick={()=>navigate("/authors")}>Authors</li>
            <li className='py-6 text-4xl'><div>
            <button className=' ' onClick={handleThemeSwitch}>
            {
      theme ==="dark" && <BsSun/>
    }
    {
      theme==="light" && <BsMoon/>
    }
  
            </button>
    

        </div></li>
            
       </ul>
       
    </div>
  )
}

export default Navbar

